import { useTranslation } from "react-i18next";

import { useAuth } from "@/shared/stores/useAuth";
import OwnedDeckCardList from "@/cards/common/component/deck-library/OwnedDeckCardList";
import { useDeckCardTalentExpandShare } from "@/cards/common/component/deck-library/useDeckCardTalentExpandShare";
import {
  SEASON_CARD_NAVIGATION,
  getSeasonCardIdFromCard,
  mapSeasonMainCardResponseToPublishedCard,
} from "@/cards/common/utils/app-deck/ownedDeckCardList.utils";

const SeasonCardTalentPage = () => {
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const { onExpandShare, shareModal } = useDeckCardTalentExpandShare({
    cardKind: "season",
  });

  return (
    <>
      <OwnedDeckCardList
        deckCardType="Season_Card"
        viewMode="talent"
        purchaseFilter="all"
        navigation={SEASON_CARD_NAVIGATION}
        titleLabel={t("my_cards", { defaultValue: "My Cards" })}
        showTalentFilter={false}
        injectTalentCreationPage
        enabled={Boolean(userInfo?.id)}
        onExpandShare={onExpandShare}
        deckCardShareKind="season"
        mapFetchedMainCard={mapSeasonMainCardResponseToPublishedCard}
        secondaryUrlParam={{
          key: "seasonCardId",
          getValue: (card) => getSeasonCardIdFromCard(card),
        }}
      />
      {shareModal}
    </>
  );
};

export default SeasonCardTalentPage;
